'use client';
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "@tameeni/shared-logic";
const PopoverProvider = PopoverPrimitive.Root;
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx(
  PopoverPrimitive.Trigger,
  {
    ...props,
    className: cn("focus-visible:ring-0", className)
  }
);
const PopoverArrow = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  PopoverPrimitive.Arrow,
  {
    ref,
    width: 21,
    height: 10,
    className: cn("fill-white", className),
    ...props
  }
));
PopoverArrow.displayName = PopoverPrimitive.Arrow.displayName;
const PopoverContent = React.forwardRef(({ className, sideOffset = 4, side = "bottom", ...props }, ref) => /* @__PURE__ */ jsx(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx(
  PopoverPrimitive.Content,
  {
    ref,
    sideOffset,
    side,
    className: cn(
      "focus-visible:outline-none shadow-lg w-full md:max-w-[288px] bg-white z-[60] overflow-hidden rounded-lg px-4 py-5 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 duration-200 delay-0",
      className
    ),
    ...props
  }
) }));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverProvider,
  PopoverTrigger
};
